module.exports = __webpack_public_path__ + "static/media/deadpool.4b6c9293.png";